import FormsInterface from './FormsInterface';

export default class Forms implements FormsInterface{
  id: string
  label: string
  product_choice_element_id: string | null

  constructor(id: string, label: string, product_choice_element_id: string | null) {
    this.id = id
    this.label = label
    this.product_choice_element_id = product_choice_element_id
  }
}
